
<span *ngIf="transformedSpanContent !== ''" [innerHTML]="transformedSpanContent"></span>

<!-- We need to set the adp-img-fluid class so that it is responsive to the parent. Without this class, the image doesn't match the dimensions of the adp-image element itself (so it won't be responsive). -->
<img *ngIf="transformedImgContent !== ''" [src]="transformedImgContent" class="{{imageClass}}" [class.adp-img-fluid]="true" alt="{{transformedImageAlt}}" />
